module.exports = __webpack_public_path__ + "assets/img/2010.c96f268f.svg";